import React, { PureComponent } from "react";
import classnames from "classnames";
import { abbreviateNumber, getTimeByDurationFormat } from "Utils";
import styles from "./Charts.local.scss";

export class CustomizedYAxisTick extends PureComponent {
  render() {
    const { x, y, payload, currency } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={3}
          dx={-2}
          textAnchor="end"
          fill="#6D7F92"
          fontSize={12}
          className={classnames(styles.axis_tick, styles.axis_y)}
        >
          {abbreviateNumber(payload.value)} {currency ? "h" : ""}
        </text>
      </g>
    );
  }
}

export class CustomizedXAxisTick extends PureComponent {
  render() {
    const { x, y, payload, month, day, period } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="middle"
          fill={
            month === payload.value ||
            (day && day.toString() === payload.value.toString())
              ? "#db0606"
              : "#6D7F92"
          }
          fontSize={
            month === payload.value ||
            (day && day.toString() === payload.value.toString())
              ? 14
              : 12
          }
          className={classnames(
            styles.axis_tick,
            styles.axis_x,
            month === payload.value ||
            (day && day.toString() === payload.value.toString())
              ? styles.axis_x_label
              : ""
          )}
          onClick={() =>
            period === "MONTHLY"
              ? this.props.handleChangeDayState(payload.value)
              : this.props.handleChangeMonthState(payload.value)
          }
          style={{
            cursor: "pointer"
          }}
        >
          {payload.value}
        </text>
      </g>
    );
  }
}

export class CustomizedXAxisTickRotated extends PureComponent {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          transform="rotate(-35)"
          fill="#6D7F92"
          fontSize={12}
          className={classnames(styles.axis_tick, styles.axis_x)}
        >
          {payload.value}
        </text>
      </g>
    );
  }
}

export class CustomTooltip extends PureComponent {
  render() {
    const { active, format } = this.props;

    if (active) {
      const { payload, label } = this.props;
      return (
        <div className={styles.custom_tooltip}>
          <p className={styles.label}>{`${label}`}</p>
          {payload.map((item, i) => {
            return (
              <p key={i} className={styles.intro} style={{ color: item.color }}>
                {item.name} :{" "}
                <b>
                  {format === "H"
                    ? getTimeByDurationFormat(item.value)
                    : item.value}
                </b>
              </p>
            );
          })}
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/Common.js